import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import CoursesLayer from "../components/CoursesLayer";

const CoursesPage = () => {
  return (
    <>
   
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Courses  </h5><Breadcrumb title="Courses" /></div>

        {/* AssignRoleLayer */}
        <CoursesLayer />
  
    </>
  );
};

export default CoursesPage;
